import { MediaMatcher } from '@angular/cdk/layout';
import { AfterViewInit, Component, inject } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Route, Router, RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import { AuthenticationFormComponent } from '@pcscol-portail/ng-auth';
import { hasAnyTraitement } from '@pcscol-portail/ng-authz';
import {
  FooterComponent,
  HeaderComponent,
  PcscolIconsModule,
  Mode,
} from '@pcscol-portail/composants-pegase';
import { of } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    AuthenticationFormComponent,
    HeaderComponent,
    MatSidenavModule,
    MatListModule,
    FooterComponent,
    PcscolIconsModule,
  ],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App implements AfterViewInit {
  public readonly mode: Mode = Mode.APPRENANT;
  appTitle = $localize`:@@PIECES-APP-TITLE:Pièces Justificatives`;

  navRoutes!: Route[];
  version: string = environment.version;

  public router = inject(Router);
  public media = inject(MediaMatcher);
  public store = inject(Store);

  ngAfterViewInit() {
    this.navRoutes = this.router.config
      .find((route) => route.path === ':codeStructure')
      ?.children?.filter((r) => r.data != null && r.data['navTitle'] != null) as Route[];
  }

  isAuthorized$(listeActionMetier: Array<string>) {
    if (listeActionMetier != null) {
      return this.store.select(hasAnyTraitement, listeActionMetier);
    }
    return of(true);
  }
}
